import { useTranslation } from 'react-i18next';
import Button from '../../../components/Button';
import Comment from '../../../components/Comment';
import Modal from '../../../components/Modal/Modal';
import { DEFAULT_ERROR } from '../../../components/Notifications/Notification';
import { generateConfirmationFileLink } from '../../../core/api';
import { downloadFile, formatDate } from '../../../core/helpers';
import { addNotification } from '../../../core/store/notificationsSlice';
import { PaymentConfirmationFile } from '../../../core/types';
import { useAppDispatch, useAppSelector } from '../../../hooks';

import SellerFillingFile from './SellerFillingFile';

interface Props {
  isModalOpened: boolean;
  closeModal: () => void;
  files: PaymentConfirmationFile[];
  date?: Date;
  comment?: string;
}

export default function SellerFilingFilesModal({
  isModalOpened,
  closeModal,
  files,
  date,
  comment,
}: Props) {
  const { t } = useTranslation();
  const activeCompany = useAppSelector((s) => s.user.activeCompany);
  const dispatch = useAppDispatch();

  const onDowloadFile =
    (file: PaymentConfirmationFile) =>
    (setIsLoading: React.Dispatch<React.SetStateAction<boolean>>) =>
    () => {
      setIsLoading(true);
      generateConfirmationFileLink(file.id, activeCompany?.company_id)
        .then((res) => {
          setIsLoading(false);
          downloadFile(res, file.filename);
        })
        .catch(() => {
          setIsLoading(false);
          dispatch(
            addNotification({
              text: t(DEFAULT_ERROR),
              type: 'error',
            })
          );
        });
    };

  return (
    <Modal isOpened={isModalOpened} close={closeModal} title={t('Files')}>
      <div className='mx-3 pt-3 pb-4 px-3'>
        {date && (
          <div className='Text--20 fw-800 mb-2'>
            {formatDate(date, 'MMMM yyyy')}
          </div>
        )}
        <div className='fw-600 mb-2'>{t('Proof of submission')}</div>
        {comment && <Comment comment={comment} className='mb-2' />}
        {files.map((f) => (
          <SellerFillingFile
            key={f.id}
            filename={f.filename}
            className='mb-3'
            onDownload={onDowloadFile(f)}
          />
        ))}
        <div>
          <Button
            styling='outline'
            type='button'
            onClick={closeModal}
            data-testid='payment-instruction-modal-close-button'
          >
            {t('Close')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
